import XAPPService from "app/Core/services/XAPPService";
import Constante from "Constante.json";
import dayjs from "dayjs";
import md5 from "js-md5";
import _ from "lodash";
export const MEMED_WARNING = "[MEMED APP] MEMED WARNING";
export const MEMED_INFO = "[MEMED APP] MEMED INFO";
export const MEMED_ERROR = "[MEMED APP] MEMED ERROR";
export const GET_TOKEN = "[MEMED APP] GET TOKEN";
export const TOKEN_PENDENTE = "[MEMED APP] TOKEN PENDENTE";
export const GET_PDF = "[MEMED APP] GET PDF";

const GetState = [
    "setup",
];

export function getToken(_AParams) {

    return (dispatch) => {

        var AConditionsAND = [{ Campo: "integracao.tipo", Operador: "=", Valor: Constante.memed }];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "integracao", AActions, "spvwintegracao", GetState, "SELECIONAR", AConditionsAND, AConditionsOR);

        XAPPService.XappSelAction(AActions, _AParams)
            .then((response) => {
                if (_.isNull(JSON.parse(response.data)[0].data)) {
                    return dispatch({
                        type: TOKEN_PENDENTE,
                    });
                }
                else {
                    return dispatch({
                        type: GET_TOKEN,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data[0] : "",
                    });
                }
            }
            )
            .catch(error => {
                return dispatch({
                    type: MEMED_ERROR,
                    payload: error
                });
            });
    };
}

export function saveDocumentoMemed(_AValue, _AParams, _ACallback = null) {
    return (dispatch) => {

        var AActions = [];

        AActions = XAPPService.XappIntegracaoActionFactory(_AParams.empresa, AActions, "", "", _AValue);

        XAPPService.XappIntegracaoAction(AActions, _AParams, "PDF_MEMED")
            .then((response) => {
                if (response.data) {
                    return dispatch({
                        type: GET_PDF,
                        payload: {
                            "id": md5("" + _AValue.id),
                            "conteudo": _AValue.conteudo,
                            "descricao": "Receituário Memed",
                            "arquivo": true,
                            "caminho": response.data.caminho,
                            "datadescricao": "21/02/2022 13:49:45"
                        }
                    });
                }
                if (!_.isNull(_ACallback) && !_.isNull(response.info)) {
                    _ACallback(_AValue);
                }
            })
            .catch(() => {
                return dispatch({
                    type: GET_PDF,
                    payload: {
                        "id": md5("" + _AValue.id),
                        "conteudo": _AValue.conteudo,
                        "descricao": "Receituário Memed",
                        "arquivo": true,
                        "caminho": null,
                        "datadescricao": dayjs(new Date()).format("DD/MM/YYYY HH:mm")
                    }
                });
            });
    };
}

export function clearToken() {
    return {
        type: GET_TOKEN,
        payload: null
    };
}

export function clearPDF() {
    return {
        type: GET_PDF,
        payload: null
    };
}

